export default "__VITE_PUBLIC_ASSET__228189da__"